/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, useRef } from 'react'
import { useClickAway } from 'react-use'
import { styles } from './styles'

interface DropdownProps {
  width?: number
  onClose: () => any
}

export const Dropdown: FunctionComponent<DropdownProps> = ({
  width,
  onClose,
  children,
}) => {
  const ref = useRef(null)

  useClickAway(ref, onClose)

  return (
    <div css={styles.container} style={{ width }} ref={ref}>
      {children}
    </div>
  )
}
